import Layout from '@/views/main/Main.vue'
import type { RouteRecordRaw } from "vue-router";
const statisticalRouter: RouteRecordRaw = {
    path: '/statistical',
    component: Layout,
    redirect: '/statistical/delivery',
    meta: {
        icon: 'el-icon-s-order',
        title: '统计分析查询'
    },
    children: [

        {
            path: '/statistical/receivingRecord',
            component: () => import('@/views/main/statistical/receivingRecord/receivingRecord.vue'),
            name: 'receivingRecord',
            meta: {
                title: '收货列表'
            },
        },
        {
            path: '/statistical/receivingsearch',
            component: () => import('@/views/main/statistical/receivingsearch/receivingsearch.vue'),
            name: 'receivingsearch',
            meta: {
                title: '收货查询'
            },
        },        
        {
            path: '/statistical/locationView',
            component: () => import('@/views/main/statistical/locationView/locationView.vue'),
            name: 'locationView',
            meta: {
                title: '库位视图'
            },
        },
        {
            path: '/statistical/inventoryList',
            component: () => import('@/views/main/statistical/inventoryList/inventoryList.vue'),
            name: 'inventoryList',
            meta: {
                title: '库存列表'
            },
        },
        {
            path: '/statistical/inventorySearch',
            component: () => import('@/views/main/statistical/inventorySearch/inventorySearch.vue'),
            name: 'inventorySearch',
            meta: {
                title: '库存查询'
            },
        },   
        {
            path: '/statistical/warehouseStatistics',
            component: () => import('@/views/main/statistical/warehouseStatistics/index.vue'),
            name: 'warehouseStatistics',
            meta: {
                title: '仓库统计'
            },
        },     
        {
            path: '/statistical/historyTask',
            component: () => import('@/views/main/statistical/historyTask/historyTask.vue'),
            name: 'historyTask',
            meta: {
                title: '历史任务'
            },
        },
        {
            path: '/statistical/inAndOutDetail',
            component: () => import('@/views/main/statistical/inAndOutDetail/inAndOutDetail.vue'),
            name: 'inAndOutDetail',
            meta: {
                title: '出入明细'
            },
        },
        {
            path: '/statistical/salesManagement',
            component: () => import('@/views/main/statistical/salesManagement/salesManagement.vue'),
            name: 'salesManagement',
            meta: {
                title: '退货管理'
            },
        },






        {
            path: '/statistical/outInRecord',
            component: () => import('@/views/main/statistical/outInRecord/outInRecord.vue'),
            name: 'outInRecord',
            meta: {
                title: '出入库记录查询'
            },
        },
        {
            path: '/statistical/sortRecord',
            component: () => import('@/views/main/statistical/sortRecord/sortRecord.vue'),
            name: 'sortRecord',
            meta: {
                title: '分拣记录查询'
            },
        },
        {
            path: '/statistical/starving',
            component: () => import('@/views/main/statistical/starving/starving.vue'),
            name: 'starving',
            meta: {
                title: '缺料信息查询'
            },
        },
        {
            path: "/statistical/entryOrder",
            component: () => import("@/views/main/invoices/noorder/inventory.vue"),
            name: "inventory",
            meta: {
                title: "库存记录查询"
            }
        },
        {
            path: "/statistical/luckySheet",
            component: () => import("@/views/main/statistical/barcode/barcode.vue"),
            name: "BarCode",
            meta: {
                title: "在编编辑测试"
            }
        },

        {
            path: "/statistical/recordSearch",
            component: () => import("@/views/main/statistical/recordSearch/recordSearch.vue"),
            name: "recordSearch",
            meta: {
                title: "报表查询"
            }
        },
        {
            path: "/statistical/inspectionRecordManage",
            component: () => import("@/views/main/statistical/inspectionRecordManage/inspectionRecordManage.vue"),
            name: "inspectionRecordManage",
            meta: {
                title: "供应商质检统计"
            }
        },
    ]
}

//统计分析查询路由
export default statisticalRouter